document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('quickProductModal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.close');
  const mainImage = document.getElementById('productMainImage');
  const thumbnailsContainer = document.getElementById('productThumbnails');
  const titleEl = document.getElementById('productTitle');
  const priceRegEl = document.getElementById('productPrice');
  const priceSaleEl = document.getElementById('productPriceSale');
  const descEl = document.getElementById('productDescription');
  const variantsContainer = document.getElementById('variantOptions');
  const quantityInput = document.getElementById('quantity');
  const addToCartBtn = document.getElementById('addToCartBtn');
  const detailsLink = document.getElementById('viewDetailsLink');

  let currentProduct = null;
  let selectedVariantId = null;

  // 1. ABRIR MODAL
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.open-quick-view-btn, .open-product-modal, .custom-add-to-cart-btn');
    if (btn) {
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      if (handle) loadProductData(handle);
    }
  });

  // 2. CERRAR MODAL
  function closeModal() {
    modal.classList.remove('active');
    setTimeout(() => { 
      modal.style.display = 'none'; 
    }, 300);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });

  // 3. CONTROLES DE CANTIDAD (+ / -)
  modal.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      let currentVal = parseInt(quantityInput.value) || 1;
      if (this.dataset.action === 'increase') {
        quantityInput.value = currentVal + 1;
      } else if (this.dataset.action === 'decrease' && currentVal > 1) {
        quantityInput.value = currentVal - 1;
      }
    });
  });

  // 4. CARGAR PRODUCTO DESDE SHOPIFY
  function loadProductData(handle) {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        currentProduct = product;
        renderModal(product);
        modal.style.display = 'flex';
        setTimeout(() => modal.classList.add('active'), 10);
      })
      .catch(err => console.error('Error al cargar datos del producto:', err));
  }

  // 5. RENDERIZAR INFORMACIÓN Y OPCIONES EN EL MODAL
  function renderModal(product) {
    titleEl.textContent = product.title;
    
    // Acordeón detalles
    if (product.description && product.description.trim() !== '') {
      descEl.innerHTML = `
        <details class="product-details-accordion">
          <summary class="accordion-header">
            <span>DETALLES TÉCNICOS</span>
            <span class="accordion-icon">+</span>
          </summary>
          <div class="accordion-content">
            ${product.description}
          </div>
        </details>
      `;
    } else {
      descEl.innerHTML = '';
    }

    detailsLink.href = `/products/${product.handle}`;
    quantityInput.value = 1;
    mainImage.src = product.featured_image || '';

    // Miniaturas
    thumbnailsContainer.innerHTML = '';
    if (product.images && product.images.length > 1) {
      product.images.forEach((imgSrc) => {
        const thumb = document.createElement('img');
        thumb.src = imgSrc;
        thumb.addEventListener('click', () => mainImage.src = imgSrc);
        thumbnailsContainer.appendChild(thumb);
      });
    }

    variantsContainer.innerHTML = '';

    const isB2B = Boolean(window.isB2BUser);

    if (product.variants && product.variants.length > 1 && product.options) {
      variantsContainer.style.display = 'block';

      product.options.forEach((option, optionIndex) => {
        let validValues = option.values || [];

        // Filtro B2B
        if (!isB2B) {
          validValues = validValues.filter(value => {
            const valLower = value.toLowerCase();
            return !valLower.includes('3 kg') && !valLower.includes('3kg');
          });
        }

        if (validValues.length <= 1) {
          return;
        }

        const variantGroup = document.createElement('div');
        variantGroup.className = 'variant-group';

        const label = document.createElement('label');
        label.className = 'variant-label';
        label.textContent = option.name + ':';

        const select = document.createElement('select');
        select.className = 'variant-select option-select';
        select.dataset.optionIndex = optionIndex;

        validValues.forEach(value => {
          const optionEl = document.createElement('option');
          optionEl.value = value;
          optionEl.textContent = value;
          select.appendChild(optionEl);
        });

        select.addEventListener('change', updateSelectedVariant);
        variantGroup.appendChild(label);
        variantGroup.appendChild(select);
        variantsContainer.appendChild(variantGroup);
      });

      updateSelectedVariant();
    } else {
      variantsContainer.style.display = 'none';
      if (product.variants && product.variants.length > 0) {
        updatePrice(product.variants[0]);
      }
    }
  }

  // 6. BUSCAR LA VARIANTE CORRESPONDIENTE A LA COMBINACIÓN ELEGIDA
  function updateSelectedVariant() {
    if (!currentProduct || !currentProduct.variants) return;

    const selects = Array.from(modal.querySelectorAll('.option-select'));
    
    // Mapeamos los valores elegidos según su posición de opción real en Shopify
    const selectedOptionsMap = {};
    selects.forEach(select => {
      const idx = select.dataset.optionIndex;
      selectedOptionsMap[idx] = select.value;
    });

    // Encontrar la variante que coincide con los selects activos
    let matchedVariant = currentProduct.variants.find(variant => {
      return Object.keys(selectedOptionsMap).every(idx => {
        return variant.options[parseInt(idx)] === selectedOptionsMap[idx];
      });
    });

    // Si no hay combinación válida seleccionada, tomar la primera disponible
    if (!matchedVariant) {
      matchedVariant = currentProduct.variants[0];
    }

    if (matchedVariant) {
      updatePrice(matchedVariant);
      if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
        mainImage.src = matchedVariant.featured_image.src;
      }
    }
  }

  // 7. ACTUALIZAR PRECIOS Y ESTADO DEL BOTÓN
  function updatePrice(variant) {
    if (!variant) return;
    
    selectedVariantId = variant.id;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceRegEl.textContent = formatMoney(variant.compare_at_price);
      priceRegEl.style.textDecoration = 'line-through';
      priceSaleEl.textContent = formatMoney(variant.price);
      priceSaleEl.style.display = 'inline';
    } else {
      priceRegEl.textContent = formatMoney(variant.price);
      priceRegEl.style.textDecoration = 'none';
      priceSaleEl.style.display = 'none';
    }

    if (!variant.available) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Agotado';
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Añadir a la cesta';
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  // 8. AÑADIR AL CARRITO (AJAX) Y ACTUALIZAR SINS RECARGAR
  addToCartBtn.addEventListener('click', function () {
    const variantId = selectedVariantId || (currentProduct && currentProduct.variants[0].id);
    const qty = parseInt(quantityInput.value) || 1;

    if (!variantId) return;

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Añadiendo...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
    .then(res => {
      if (!res.ok) throw new Error('Error al añadir al carrito');
      return res.json();
    })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cartData => {
      closeModal();
      
      // Actualiza contador visual de productos en la web
      document.querySelectorAll('.cart-count, .cart-bubble, [data-cart-count]').forEach(el => {
        el.textContent = cartData.item_count;
      });

      // Dispara evento para que el tema de Shopify refresque el mini-cart si tiene eventos propios
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cartData }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
    })
    .catch(err => {
      console.error('Error al añadir al carrito:', err);
      alert('Hubo un error al añadir el producto a la cesta.');
    })
    .finally(() => {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Añadir a la cesta';
    });
  });
});